import {DEFAULT_EMOJI_CDN} from '../../const'
const Emoji = {
    cdn: DEFAULT_EMOJI_CDN,
    maps : require('./weibo.json'),
    parse: str=>String(str).replace(new RegExp(":("+Object.keys(Emoji.maps).join('|')+"):","ig"),(raw,key)=>Emoji.maps[key] ? Emoji.build(key) : raw),
    build : key => {
        let re = /^(https?:)?\/\//i, v = Emoji.maps[key], s = re.test(v) ? v : Emoji.cdn+v
        return re.test(s) ? '<img alt="'+key+'" referrerPolicy="no-referrer" class="vemoji" src="'+s+'" />' : ''
    }
    // parse : str => String(str).replace(/:(.+?):/g, (raw, key) => Emoji.maps[key] || raw)
}
export default Emoji